import svg4everybody from 'svg4everybody';
import './_vendor/swiper.js';
import './_vendor/select2.min.js';
import './_vendor/jquery-validation.js';
// import './_vendor/jquery.inputmask.bundle.min.js';

svg4everybody();
